import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IEmployeeState }       from 'Redux/Slices/Employee/EmployeeSlice';
import { Employee }             from 'Domain/Models';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const findEmployeeRequest = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findEmployeeSuccess = (state: Draft<IEmployeeState>, { type, payload }: PayloadAction<{
  employee: Employee
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.employee.id]: payload.employee };
};

export const findEmployeeFailure = (state: Draft<IEmployeeState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
